import { Component } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { CommonModule } from '@angular/common';
import { AppSettings } from 'src/app/app.config';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AccountService } from '../../api/services';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, filter } from 'rxjs/operators';
import { Subscription, throwError } from 'rxjs';
import { ManageUserProfile } from '../../api/models';

@Component({
  selector: 'app-billing-form',
  templateUrl: './billing-form.component.html',
  styleUrls: [],
})
export class BillingFormComponent {
  private htmlElement!: HTMLHtmlElement;

  constructor(private settings: CoreService,
    private translate: TranslateService,
    private router: Router) {
    this.htmlElement = document.querySelector('html')!;
    // Initialize project theme with options
  }
}
